import KAMPYLE_DATA from "../modules/KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "../modules/KAMPYLE_EVENT_DISPATCHER";

  var formIdPlaceHolder = '{{FORM_ID}}';
  var gaEventQueue = [];
  var numAttempts = 0;
  var isGtm = false;

  var CONFIG = {
    POLLING_INTERVAL: 5000,
    POLLING_COUNTER: 3
  };

  var gaEvents = {
    'neb_formShown': {
      category: 'NebulaCX',
      action: 'Form_Displayed',
      label: formIdPlaceHolder
    },
    'neb_showInvitation': {
      category: 'NebulaCX',
      action: 'Invite_Triggered',
      label: formIdPlaceHolder
    },
    'neb_inviteDeclined': {
      category: 'NebulaCX',
      action: 'Invite Rejected',
      label: formIdPlaceHolder
    },
    'neb_inviteAccepted': {
      category: 'NebulaCX',
      action: 'Invite_Accepted',
      label: formIdPlaceHolder
    },
    'neb_formTriggerdByCode': {
      category: 'NebulaCX',
      action: 'Form_Triggered_By_Code',
      label: formIdPlaceHolder
    },
    'neb_buttonClicked': {
      category: 'NebulaCX',
      action: 'Button_Clicked',
      label: formIdPlaceHolder
    },
    'neb_sdkShowForm': {
      category: 'NebulaCX',
      action: 'Form_Triggered_By_Code',
      label: formIdPlaceHolder
    },
    'neb_feedbackSubmitted': {
      category: 'NebulaCX',
      action: 'Feedback_Submitted',
      label: formIdPlaceHolder
    },
    'neb_feedbackPostSubmitted': {
      category: 'NebulaCX',
      action: 'Feedback_Submitted',
      label: formIdPlaceHolder
    },
    'neb_formClosed': {
      category: 'NebulaCX',
      action: 'Form_Close',
      label: formIdPlaceHolder
    },
    'neb_popupBlocked': {
      category: 'NebulaCX',
      action: 'Popup_Blocked',
      label: formIdPlaceHolder,
    },
   'neb_formPageShown': {
      category: 'NebulaCX',
      action: 'Form_Page_Displayed',
      label: formIdPlaceHolder
    },
    'neb_captureInit': {
      category: 'NebulaCX',
      action: 'Screen_Capture_Init',
      label: formIdPlaceHolder
    },
    'neb_captureImageClicked': {
      category: 'NebulaCX',
      action: 'Capture_Image_Click',
      label: formIdPlaceHolder
    },
    'MDigital_Capture_Cancelled': {
      category: 'NebulaCX',
      action: 'Cancel_Capture_Click',
      label: formIdPlaceHolder
    },
    screenCaptureDelete: {
      category: 'NebulaCX',
      action: 'Screen_Capture_Delete',
      label: formIdPlaceHolder
    },
    screenCaptureRetake: {
      category: 'NebulaCX',
      action: 'Screen_Capture_Retake',
      label: formIdPlaceHolder
    },
    'MDigital_Form_Close_No_Submit': {
      category: 'NebulaCX',
      action: 'Form_Close_No_Submit',
      label: formIdPlaceHolder
    },
    'MDigital_Form_Next_Page': {
      category: 'NebulaCX',
      action: 'Form_Next_Page',
      label: formIdPlaceHolder
    },
    'MDigital_Form_Back_Page': {
      category: 'NebulaCX',
      action: 'Form_Back_Page',
      label: formIdPlaceHolder
    },
    'MDigital_ThankYou_Displayed': {
      category: 'NebulaCX',
      action: 'ThankYou_Displayed',
      label: formIdPlaceHolder
    },
    'MDigital_ThankYou_Close': {
      category: 'NebulaCX',
      action: 'ThankYou_Close',
      label: formIdPlaceHolder
    }
  };

  var allowedDataFields = ['pageNumber'];

  var getValueByAllowedFields = function(data) {
    var value;

    for (var i = allowedDataFields.length - 1; i >= 0; i--) {
      var currField = allowedDataFields[i];
      if (data[currField] !== undefined)
      {
        var toNumber = Number(data[currField]);
        if (!isNaN(toNumber))
        {
          return toNumber;
        }
      }
    };

    return value;
  };

  var sendGaEvent = function(eventName,data) {
    var category = (!!gaEvents[eventName] && !!gaEvents[eventName].category) ? gaEvents[eventName].category : 'NebulaCX';
    var action = (!!gaEvents[eventName] && !!gaEvents[eventName].action) ? gaEvents[eventName].action : undefined;
    var label = (!!gaEvents[eventName] && gaEvents[eventName].label === formIdPlaceHolder && data.formId) ? data.formId : undefined;

    var value = getValueByAllowedFields(data);

    if( !!isGtm ){
      window.dataLayer.push({
        'event': 'NebulaCXgaTriggerEvent',
        'gaEventCategory': category,
        'gaEventAction': action,
        'gaEventLabel': label,
        'gaEventValue': value
      });
    }
    else{
      window.ga('send','event',category,action,label,value);
    }

  };


  var dequeueEvents = function(eventName,data) {
    //isGtm -> !datalayer ||
    //!isGtm -> !ga
    if ( (!window.ga && !isGtm) || ( !!isGtm && !window.dataLayer) )  //Meaning Google Analytics hasn't been loaded yet
    {

      numAttempts++;
      if (numAttempts < CONFIG.POLLING_COUNTER)
      {
        window.setTimeout(dequeueEvents, CONFIG.POLLING_INTERVAL);
      }
    }
    else { //ga exists
      var queueLen = gaEventQueue.length;
      for (var i = 0; i < queueLen; i++) {
        sendGaEvent(gaEventQueue[i].eventName, gaEventQueue[i].data);
      }

      //Reset queue
      numAttempts = 0;
      gaEventQueue = [];
    }
  };


  //TODO - put event nane as part of the data
  var triggerEvent = function(eventName,data) {
    gaEventQueue = gaEventQueue || [];

    if (!!eventName && !!data)
    {
      gaEventQueue.push({
        eventName: eventName,
        data: data
      });
    }
    dequeueEvents();
  };

  var init = function() {
    isGtm = KAMPYLE_DATA.isFeatureEnabled('GTM');
    for (var prop in gaEvents)
    {
      KAMPYLE_EVENT_DISPATCHER.subscribe(prop,triggerEvent);
    }

    return true;
  };


  export default {
    init: init,
    triggerEvent:triggerEvent,
    sendGaEvent: sendGaEvent //for tests
  };
